(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["ddb-banner-carousel"] && !Shopify.designMode) return;
  try {
    
document.querySelectorAll('[data-ddb-banners]').forEach(function(carousel){var track=carousel.querySelector('.ddb-banners__track');var slides=Array.from(track.children);var dots=Array.from(carousel.querySelectorAll('[data-banner-dot]'));var active=0;function go(index){active=(index+slides.length)%slides.length;track.scrollTo({left:slides[active].offsetLeft,behavior:'smooth'});dots.forEach(function(dot,i){if(i===active){dot.setAttribute('aria-current','true')}else{dot.removeAttribute('aria-current')}})}var previous=carousel.querySelector('[data-banner-prev]');var next=carousel.querySelector('[data-banner-next]');if(previous)previous.addEventListener('click',function(){go(active-1)});if(next)next.addEventListener('click',function(){go(active+1)});dots.forEach(function(dot){dot.addEventListener('click',function(){go(Number(dot.dataset.bannerDot))})})})

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ddb-hero"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('.ddb-slideshow').forEach((slideshow) => {
    const slides = [...slideshow.querySelectorAll('[data-slide]')];
    const dots = [...slideshow.querySelectorAll('[data-slide-dot]')];
    if (slides.length < 2) return;
    let index = 0;
    let timer;
    let touchStart = 0;
    const show = (next) => {
      index = (next + slides.length) % slides.length;
      slides.forEach((slide, position) => {
        const active = position === index;
        slide.classList.toggle('is-active', active);
        slide.setAttribute('aria-hidden', String(!active));
      });
      dots.forEach((dot, position) => {
        const active = position === index;
        dot.classList.toggle('is-active', active);
        dot.setAttribute('aria-current', String(active));
      });
    };
    const stop = () => window.clearInterval(timer);
    const start = () => {
      stop();
      if (slideshow.dataset.autoplay === 'true' && !window.matchMedia('(prefers-reduced-motion: reduce)').matches) timer = window.setInterval(() => show(index + 1), Number(slideshow.dataset.speed || 6000));
    };
    slideshow.querySelector('[data-slide-prev]')?.addEventListener('click', () => { show(index - 1); start(); });
    slideshow.querySelector('[data-slide-next]')?.addEventListener('click', () => { show(index + 1); start(); });
    dots.forEach((dot) => dot.addEventListener('click', () => { show(Number(dot.dataset.slideDot)); start(); }));
    slideshow.addEventListener('mouseenter', stop);
    slideshow.addEventListener('mouseleave', start);
    slideshow.addEventListener('focusin', stop);
    slideshow.addEventListener('focusout', start);
    slideshow.addEventListener('touchstart', (event) => { touchStart = event.changedTouches[0].clientX; }, { passive: true });
    slideshow.addEventListener('touchend', (event) => { const distance = event.changedTouches[0].clientX - touchStart; if (Math.abs(distance) > 50) show(index + (distance < 0 ? 1 : -1)); start(); }, { passive: true });
    start();
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ddb-ugc-shop"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('click',function(event){var button=event.target.closest('.ddb-ugc-card__sound');if(!button)return;var section=button.closest('.ddb-ugc');var video=button.parentElement.querySelector('video');if(!video)return;var turnOn=video.muted;section.querySelectorAll('video').forEach(function(item){item.muted=true});section.querySelectorAll('.ddb-ugc-card__sound').forEach(function(item){item.setAttribute('aria-pressed','false');item.setAttribute('aria-label','Turn sound on')});if(turnOn){video.muted=false;video.play();button.setAttribute('aria-pressed','true');button.setAttribute('aria-label','Turn sound off')}})

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
function ddbInitMegaMenus(root){(root||document).querySelectorAll('[data-ddb-nav-shell]:not([data-ddb-ready])').forEach(function(shell){shell.dataset.ddbReady='true';var triggers=Array.from(shell.querySelectorAll('[data-ddb-nav-trigger]'));var panels=Array.from(shell.querySelectorAll('[data-ddb-mega-panel]'));var timer;function close(){triggers.forEach(function(item){item.classList.remove('is-active');item.setAttribute('aria-expanded','false')});panels.forEach(function(panel){panel.classList.remove('is-active');panel.setAttribute('aria-hidden','true');panel.querySelectorAll('video').forEach(function(video){video.pause();video.muted=true;video.currentTime=0;video.preload='none'})})}function open(id){clearTimeout(timer);close();var trigger=shell.querySelector('[data-ddb-nav-trigger="'+id+'"]');var panel=shell.querySelector('[data-ddb-mega-panel="'+id+'"]');if(!trigger||!panel)return;trigger.classList.add('is-active');trigger.setAttribute('aria-expanded','true');panel.classList.add('is-active');panel.setAttribute('aria-hidden','false');var videos=Array.from(panel.querySelectorAll('video'));videos.forEach(function(video){video.preload='auto';if(video.readyState===0)video.load();video.muted=true;video.play().catch(function(){})});if(panel.dataset.soundHover==='true'&&videos[0]){videos[0].muted=false;videos[0].play().catch(function(){videos[0].muted=true})}}triggers.forEach(function(trigger){trigger.addEventListener('mouseenter',function(){open(trigger.dataset.ddbNavTrigger)});trigger.addEventListener('focus',function(){open(trigger.dataset.ddbNavTrigger)})});shell.addEventListener('mouseleave',function(){timer=setTimeout(close,160)});shell.addEventListener('mouseenter',function(){clearTimeout(timer)});shell.addEventListener('keydown',function(event){if(event.key==='Escape'){close();triggers[0]?.focus()}})})}if(document.readyState==='loading'){document.addEventListener('DOMContentLoaded',function(){ddbInitMegaMenus(document)})}else{ddbInitMegaMenus(document)}document.addEventListener('shopify:section:load',function(event){ddbInitMegaMenus(event.target)});document.addEventListener('shopify:block:select',function(event){var trigger=event.target.querySelector('[data-ddb-nav-trigger]');if(trigger){trigger.dispatchEvent(new Event('mouseenter'))}})

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product"] && !Shopify.designMode) return;
  try {
    
  function updateDdbVariant(section, variantId) {
    const select = section.querySelector('.ddb-product-form select[name="id"]');
    if (!select) return;
    select.value = String(variantId);
    const option = select.selectedOptions[0];
    if (!option) return;
    const available = option.dataset.available === 'true';
    const price = option.dataset.price || '';
    const title = option.dataset.title || option.textContent;
    const priceElement = section.querySelector('[data-ddb-price]');
    const compareElement = section.querySelector('[data-ddb-compare]');
    const titleElement = section.querySelector('[data-ddb-variant-title]');
    const button = section.querySelector('.ddb-atc');
    if (priceElement) priceElement.textContent = price;
    if (compareElement) {
      const compareValue = Number(option.dataset.compareValue || 0);
      const priceValue = Number(option.dataset.priceValue || 0);
      compareElement.textContent = option.dataset.compare || '';
      compareElement.hidden = compareValue <= priceValue;
      const saleBadge = section.querySelector('[data-ddb-sale-badge]');
      if (saleBadge) saleBadge.hidden = compareValue <= priceValue;
    }
    if (titleElement) titleElement.textContent = title;
    if (button) {
      button.disabled = !available;
      button.textContent = available ? `${button.dataset.addLabel} — ${price}` : button.dataset.soldOutLabel;
    }
    const inventoryManaged = option.dataset.inventoryManaged === 'true';
    const inventoryQuantity = Number(option.dataset.inventoryQuantity || 0);
    const lowThreshold = Number(section.querySelector('[data-ddb-stock]')?.dataset.lowThreshold || 0);
    const isLowStock = available && inventoryManaged && inventoryQuantity > 0 && inventoryQuantity <= lowThreshold;
    const stock = section.querySelector('[data-ddb-stock]');
    if (stock) {
      stock.textContent = available ? (isLowStock ? `Only ${inventoryQuantity} left` : 'In stock and ready to dispatch') : 'Sold out';
      stock.classList.toggle('is-low', isLowStock);
    }
    const lowBadge = section.querySelector('[data-ddb-low-badge]');
    if (lowBadge) lowBadge.hidden = !isLowStock;
    const mobileButton = section.querySelector('[data-ddb-mobile-submit]');
    const mobilePrice = section.querySelector('[data-ddb-mobile-price]');
    const mobileVariant = section.querySelector('[data-ddb-mobile-variant]');
    if (mobileButton) {
      mobileButton.disabled = !available;
      mobileButton.textContent = available ? button.dataset.addLabel : button.dataset.soldOutLabel;
    }
    if (mobilePrice) mobilePrice.textContent = price;
    if (mobileVariant) mobileVariant.textContent = title;
    section.querySelectorAll('.ddb-swatch').forEach((swatch) => swatch.classList.remove('is-selected'));
    const radio = section.querySelector(`.ddb-swatch input[value="${CSS.escape(String(variantId))}"]`);
    if (radio) {
      radio.checked = true;
      radio.closest('.ddb-swatch')?.classList.add('is-selected');
    }
    const imageSource = option.dataset.imageSrc || radio?.dataset.imageSrc;
    const imageZoom = option.dataset.imageZoom || radio?.dataset.imageZoom;
    const primaryMedia = section.querySelector('.ddb-gallery__item.is-primary');
    const primaryImage = primaryMedia?.querySelector('img');
    if (imageSource && primaryImage) {
      primaryImage.src = imageSource;
      primaryImage.srcset = '';
      if (imageZoom) primaryMedia.dataset.imageSrc = imageZoom;
    }
    const url = new URL(section.dataset.productUrl, window.location.origin);
    url.searchParams.set('variant', variantId);
    window.history.replaceState({}, '', `${url.pathname}${url.search}`);
  }

  document.addEventListener('change', (event) => {
    const section = event.target.closest('.ddb-pdp');
    if (!section) return;
    if (event.target.matches('.ddb-swatch input')) updateDdbVariant(section, event.target.value);
    if (event.target.matches('.ddb-product-form select[name="id"]')) updateDdbVariant(section, event.target.value);
  });

  document.addEventListener('click', (event) => {
    const quantityButton = event.target.closest('[data-quantity-minus], [data-quantity-plus]');
    if (quantityButton) {
      const input = quantityButton.parentElement?.querySelector('input[name="quantity"]');
      if (!input) return;
      input.value = String(Math.max(1, Number(input.value || 1) + (quantityButton.hasAttribute('data-quantity-plus') ? 1 : -1)));
      return;
    }
    const opener = event.target.closest('[data-ddb-gallery-open]');
    if (opener) {
      const section = opener.closest('.ddb-pdp');
      const dialog = section?.querySelector('[data-ddb-gallery-dialog]');
      const image = dialog?.querySelector('[data-ddb-gallery-image]');
      if (!dialog || !image) return;
      image.src = opener.dataset.imageSrc;
      image.alt = opener.dataset.imageAlt || '';
      dialog.showModal();
      return;
    }
    const closeButton = event.target.closest('[data-ddb-gallery-close]');
    if (closeButton) closeButton.closest('dialog')?.close();
    if (event.target.matches('[data-ddb-gallery-dialog]')) event.target.close();
  });

  document.addEventListener('scroll', (event) => {
    const gallery = event.target.closest?.('[data-ddb-gallery]');
    if (!gallery || window.innerWidth >= 750) return;
    const current = gallery.querySelector('[data-ddb-gallery-current]');
    if (!current) return;
    const slideCount = gallery.querySelectorAll('.ddb-gallery__item').length;
    current.textContent = String(Math.min(slideCount, Math.round(gallery.scrollLeft / gallery.clientWidth) + 1));
  }, true);

  document.querySelectorAll('[data-ddb-countdown]').forEach((countdown) => {
    const value = countdown.querySelector('[data-ddb-countdown-value]');
    const deadline = new Date(countdown.dataset.deadline).getTime();
    const update = () => {
      const distance = deadline - Date.now();
      if (!Number.isFinite(deadline) || distance <= 0) {
        value.textContent = countdown.dataset.expired || 'Offer ended';
        return false;
      }
      const days = Math.floor(distance / 86400000);
      const hours = Math.floor(distance / 3600000) % 24;
      const minutes = Math.floor(distance / 60000) % 60;
      const seconds = Math.floor(distance / 1000) % 60;
      value.textContent = `${days}D : ${String(hours).padStart(2, '0')}H : ${String(minutes).padStart(2, '0')}M : ${String(seconds).padStart(2, '0')}S`;
      return true;
    };
    if (update()) {
      const timer = window.setInterval(() => { if (!update()) window.clearInterval(timer); }, 1000);
    }
  });

  document.querySelectorAll('.ddb-pdp').forEach((section) => {
    const primaryButton = section.querySelector('.ddb-atc');
    const sticky = section.querySelector('[data-ddb-mobile-atc]');
    const stickyButton = section.querySelector('[data-ddb-mobile-submit]');
    if (!primaryButton || !sticky || !stickyButton) return;
    stickyButton.addEventListener('click', () => primaryButton.click());
    const observer = new IntersectionObserver(([entry]) => {
      sticky.hidden = entry.isIntersecting || window.innerWidth >= 750;
    }, { threshold: 0.15 });
    observer.observe(primaryButton);
  });

  document.addEventListener('mouseover', (event) => {
    if (window.innerWidth < 750) return;
    const preview = event.target.closest('.ddb-gallery__item:not(.is-primary)[data-image-src]');
    if (!preview) return;
    const gallery = preview.closest('[data-ddb-gallery]');
    const primary = gallery?.querySelector('.ddb-gallery__item.is-primary');
    const image = primary?.querySelector('img');
    const previewImage = preview.querySelector('img');
    if (!image || !previewImage) return;
    image.src = previewImage.currentSrc || previewImage.src;
    image.srcset = '';
    primary.dataset.imageSrc = preview.dataset.imageSrc;
    primary.dataset.imageAlt = preview.dataset.imageAlt || '';
  });

  document.addEventListener('toggle', (event) => {
    if (!event.target.matches('.ddb-accordions details') || !event.target.open) return;
    event.target.parentElement.querySelectorAll('details[open]').forEach((details) => {
      if (details !== event.target) details.open = false;
    });
  }, true);

  document.querySelectorAll('[data-ddb-bundle-builder]').forEach((builder) => {
    const picks = [];
    const picksElement = builder.querySelector('[data-ddb-bundle-picks]');
    const countElement = builder.querySelector('[data-ddb-bundle-count]');
    const promptElement = builder.querySelector('[data-ddb-bundle-prompt]');
    const submit = builder.querySelector('[data-ddb-bundle-submit]');
    const properties = Array.from(builder.querySelectorAll('[data-ddb-bundle-property]'));

    const render = () => {
      countElement.textContent = String(picks.length);
      promptElement.textContent = picks.length === 5 ? 'Your £99.99 bundle is ready' : `Choose ${5 - picks.length} more to complete your five`;
      submit.disabled = picks.length !== 5;
      properties.forEach((input, index) => { input.value = picks[index] || ''; });
      picksElement.innerHTML = '';
      picks.forEach((choice, index) => {
        const item = document.createElement('span');
        item.className = 'ddb-bundle-pick';
        item.append(document.createTextNode(`${index + 1}. ${choice}`));
        const remove = document.createElement('button');
        remove.type = 'button';
        remove.setAttribute('aria-label', `Remove ${choice}`);
        remove.textContent = '×';
        remove.addEventListener('click', () => { picks.splice(index, 1); render(); });
        item.append(remove);
        picksElement.append(item);
      });
    };

    builder.querySelectorAll('[data-ddb-bundle-choice]').forEach((button) => {
      button.addEventListener('click', () => {
        if (picks.length >= 5) return;
        picks.push(button.dataset.choice);
        render();
      });
    });

    builder.querySelector('form')?.addEventListener('submit', (event) => {
      if (picks.length !== 5) event.preventDefault();
    });
    render();
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["search"] && !Shopify.designMode) return;
  try {
    
document.querySelectorAll('[data-discovery]').forEach((section)=>{const qs=Array.from(section.querySelectorAll('[data-question]'));if(!qs.length)return;const answers={};const result=section.querySelector('[data-result]');const progress=section.querySelector('[data-progress]');function show(n){qs.forEach((q,i)=>q.hidden=i!==n);if(progress)progress.textContent=`${n+1} / ${qs.length}`;}qs.forEach((q,i)=>q.addEventListener('click',(event)=>{const button=event.target.closest('[data-value]');if(!button)return;answers[q.dataset.question]=button.dataset.value;if(i<qs.length-1){show(i+1);return;}qs.forEach((item)=>item.hidden=true);let title='Your lip wardrobe',href='/collections/all';if(answers.shop==='five'){title='Build your five';href=section.dataset.bundle;}else if(answers.shop==='combo'||answers.finish==='mix'){title='Your lip combination';href='/products/5-piece-gloss-kit';}else if(answers.finish==='gloss'){title='Your gloss direction';href='/search?q=gloss&type=product';}else if(answers.finish==='matte'){title='Your matte direction';href='/search?q=matte&type=product';}section.querySelector('[data-result-title]').textContent=title;section.querySelector('[data-result-link]').href=href;result.hidden=false;if(progress)progress.textContent='Complete';}));section.querySelector('[data-reset]')?.addEventListener('click',()=>{result.hidden=true;show(0);});show(0);});

  } catch(e) { console.error(e); }
})();
})();
